<template>
    <b-card class="bg-t-dark-- m-1">
        <b-row>
            <b-col md="8">
                <h5>
                    {{$t("Stacked Bars Chart")}}
                </h5>
                <small class="text-secondary">
                    {{$t("Subtitle")}}
                </small>
            </b-col>
            <b-col md="4" align="end" class="text-end">
                <h5 class="text-green-">
                    3423
                </h5>
            </b-col>
        </b-row>
        <br>
        <b-row>
            <b-col>
                <BarChart
                    :height="250"
                />
            </b-col>
        </b-row>
        <br>
        <div class="m-2" no-gutters style="display:flex;flex-wrap:nowrap;">
            <div class="text-left m-3">
                <div>
                    <b-icon-circle-fill class="text-green"/>
                </div>
                <div class="mt-2">
                    <span>Legend 1</span>
                </div>
            </div>
            <div class="text-left m-3">
                <div>
                    <b-icon-circle-fill class="text-green-"/>
                </div>
                <div class="mt-2">
                    <span>Legend 2</span>
                </div>
            </div>
            <div class="text-left m-3">
                <div>
                    <b-icon-circle-fill class="text-white"/>
                </div>
                <div class="mt-2">
                    <span>Legend 3</span>
                </div>
            </div>
        </div>
    </b-card>
</template>

<script>

import BarChart from "@/components/charts/BarChart.vue"
export default {
    components:{
        BarChart
    }
}
</script>

<style>

</style>